import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ArticleDetailPage from "@/pages/detail/article/page";
import VideoDetailPage from "@/pages/detail/video/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryId",
    element: <CategoryPage />,
  },
  {
    path: "/detail/article/:articleId",
    element: <ArticleDetailPage />,
  },
  {
    path: "/detail/video/:videoId",
    element: <VideoDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;